import { CLEAR_INDISPENSABLES, SET_INDISPENSABLES } from "../action-types/indispensables";

import { IndispensablesrReduserSatate } from "./reducerStateInterface";

// orderItem is now an array of indispensable product objects, not just IDs
const initialState: IndispensablesrReduserSatate = {
  orderId: null,
  orderItem: [],
  resourceName: "cart",
};

const indispensablesReducer = (state = initialState, action: any): IndispensablesrReduserSatate => {
  switch (action.type) {
    case SET_INDISPENSABLES:
      return {
        ...state,
        ...action.payload,
        orderItem: action.payload.orderItem || state.orderItem,
      };

    case CLEAR_INDISPENSABLES:
      return initialState;

    default:
      return state;
  }
};

export default indispensablesReducer;
